export const SNACK_BAR_DURATION = 3000;
export const DEFAULT_APP_NAME = 'sale';

export const DECIMAL_NUMBER_PATTERN = new RegExp(/^[+-]?\d+(\.\d+)?$/);
